/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var XpathDesc = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,12],$V1=[1,13],$V2=[1,53],$V3=[1,14],$V4=[1,15],$V5=[1,37],$V6=[1,39],$V7=[1,40],$V8=[1,41],$V9=[1,42],$Va=[1,43],$Vb=[1,44],$Vc=[1,45],$Vd=[1,46],$Ve=[1,34],$Vf=[1,47],$Vg=[1,48],$Vh=[1,49],$Vi=[1,50],$Vj=[1,51],$Vk=[1,52],$Vl=[1,31],$Vm=[1,32],$Vn=[1,33],$Vo=[1,36],$Vp=[1,35],$Vq=[2,6],$Vr=[1,56],$Vs=[1,2,7,74,83],$Vt=[2,11],$Vu=[1,58],$Vv=[1,2,7,11,74,83],$Vw=[2,14],$Vx=[1,60],$Vy=[1,2,7,11,14,74,83],$Vz=[1,2,7,11,14,18,19,20,21,22,23,74,83],$VA=[2,27],$VB=[1,70],$VC=[1,71],$VD=[1,2,7,11,14,18,19,20,21,22,23,26,27,74,83],$VE=[2,33],$VF=[1,73],$VG=[1,74],$VH=[1,75],$VI=[1,76],$VJ=[1,2,7,11,14,18,19,20,21,22,23,26,27,30,31,32,33,74,83],$VK=[2,45],$VL=[1,83],$VM=[1,84],$VN=[1,2,7,11,14,18,19,20,21,22,23,26,27,30,31,32,33,35,37,74,83],$VO=[2,51],$VP=[1,88],$VQ=[1,2,7,11,14,18,19,20,21,22,23,26,27,30,31,32,33,35,37,73,74,83],$VR=[1,92],$VS=[2,68],$VT=[26,27,30,35,37,52,53,55,56,57,58,59,60,61,63,66,67,68,69,70,71,79,80,81,82,84],$VU=[2,54],$VV=[30,63];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"XPath":3,"Expr":4,"ExprSingle":5,"P_Expr":6,"PIPE":7,"OrExpr":8,"AndExpr":9,"P_OrExpr":10,"ROR":11,"ComparisonExpr":12,"P_AndExpr":13,"RAND":14,"AdditiveExpr":15,"SUB_AdditiveExpr":16,"GeneralComp":17,"IGUAL":18,"DIFERENTE":19,"MENOR":20,"MENORIG":21,"MAYOR":22,"MAYORIG":23,"MultiplicativeExpr":24,"P_AdditiveExpr":25,"MAS":26,"MENOS":27,"UnaryExpr":28,"P_MultiplicativeExpr":29,"POR":30,"DIV":31,"IDIV":32,"MOD":33,"PathExpr":34,"BARRA":35,"SUB_BARRA":36,"DOBLEBARRA":37,"RelativePathExpr":38,"StepExpr":39,"P_RelativePathExpr":40,"PostfixExpr":41,"AxisStep":42,"ForwardStep":43,"SUB_PredicateList":44,"ReverseStep":45,"PredicateList":46,"Predicate":47,"P_PredicateList":48,"AbbrevForwardStep":49,"ForwardAxis":50,"NameTest":51,"ARROBA":52,"RCHILD":53,"DOBLEDOSPUNTOS":54,"RDESCENDANT":55,"RATTRIBUTE":56,"RSELF":57,"RDESSELF":58,"RFOLLOWSIBLING":59,"RFOLLOW":60,"RNAMESPACE":61,"NodeTest":62,"NOMBRE":63,"AbbrevReverseStep":64,"ReverseAxis":65,"DOBLEPUNTO":66,"RPARENT":67,"RANCESTOR":68,"RPRECEDSIBLING":69,"RPRECED":70,"RANCESTORORSELF":71,"PrimaryExpr":72,"CORA":73,"CORB":74,"Literal":75,"FunctionCall":76,"ContextItemExpr":77,"ParenthesizedExpr":78,"INTEGER":79,"DECIMAL":80,"CADENA":81,"PARENTESISA":82,"PARENTESISC":83,"PUNTO":84,"$accept":0,"$end":1},
terminals_: {2:"error",7:"PIPE",11:"ROR",14:"RAND",18:"IGUAL",19:"DIFERENTE",20:"MENOR",21:"MENORIG",22:"MAYOR",23:"MAYORIG",26:"MAS",27:"MENOS",30:"POR",31:"DIV",32:"IDIV",33:"MOD",35:"BARRA",37:"DOBLEBARRA",52:"ARROBA",53:"RCHILD",54:"DOBLEDOSPUNTOS",55:"RDESCENDANT",56:"RATTRIBUTE",57:"RSELF",58:"RDESSELF",59:"RFOLLOWSIBLING",60:"RFOLLOW",61:"RNAMESPACE",63:"NOMBRE",66:"DOBLEPUNTO",67:"RPARENT",68:"RANCESTOR",69:"RPRECEDSIBLING",70:"RPRECED",71:"RANCESTORORSELF",73:"CORA",74:"CORB",79:"INTEGER",80:"DECIMAL",81:"CADENA",82:"PARENTESISA",83:"PARENTESISC",84:"PUNTO"},
productions_: [0,[3,1],[3,1],[4,2],[4,2],[6,3],[6,0],[6,3],[5,1],[8,2],[10,3],[10,0],[9,2],[13,3],[13,0],[12,2],[16,2],[16,0],[17,1],[17,1],[17,1],[17,1],[17,1],[17,1],[15,2],[25,3],[25,3],[25,0],[24,2],[29,3],[29,3],[29,3],[29,3],[29,0],[28,1],[28,2],[28,2],[34,2],[34,2],[34,1],[36,1],[36,0],[38,2],[40,3],[40,3],[40,0],[39,1],[39,1],[42,2],[42,2],[44,1],[44,0],[46,2],[48,2],[48,0],[43,1],[43,2],[49,2],[49,1],[50,2],[50,2],[50,2],[50,2],[50,2],[50,2],[50,2],[50,2],[62,1],[51,1],[51,1],[45,1],[45,2],[64,1],[65,2],[65,2],[65,2],[65,2],[65,2],[41,2],[47,3],[72,1],[72,1],[72,1],[72,1],[75,1],[75,1],[75,1],[76,3],[77,1],[78,2],[78,3]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:

      grafo.generarPadre(1, "INICIO");grafo.generarHijos("Expr");
      var retornoErrores = Object.assign([], ListaErrores);
      ListaErrores = [];
      var retornoGrafo = Object.assign({}, grafo);
      grafo = new grafoCST();
      this.$=new Comando($$[$0],retornoGrafo.pilaNodos,retornoGrafo.PilaEdges,retornoGrafo.GrahpvizNodo+retornoGrafo.GrahpvizEdges,retornoErrores,retornoGrafo.TablaGramatica);
      return this.$ 
   
break;
case 2:
  
      ListaErrores.push({Error:"Error sintactico :"+yytext,tipo:"Sintactico",Linea:this._$.first_line,columna:this._$.first_column});
      var retornoErrores = Object.assign([], ListaErrores);
      ListaErrores = [];
      grafo = new grafoCST(); 
      return new Comando([],[],[],"",retornoErrores,[])
    
break;
case 3:
 
      this.$ = $$[$0]; this.$.push($$[$0-1]);
      grafo.generarPadre(2, "P_Expr");
      grafo.generarPadre(1, "ExprSingle");
      grafo.generarHijos("ExprSingle", "P_Expr");
      grafo.generarTexto(`P_Expr.push(ExprSingle.valor);`);
    
break;
case 4:
 
        this.$=[];this.$.push($$[$0-1]);
        grafo.generarPadre(1,"ExprSingle");
        grafo.generarHijos("ExprSingle","error") 
        grafo.generarTexto(`Expr.push(ExprSingle.valor); Expr.valor = []; new Error();`); 
        ListaErrores.push({Error:"Error sintactico se recupero en:"+yytext,tipo:"Sintactico",Linea:this._$.first_line,columna:this._$.first_column}); 
      
break;
case 5:
 
      this.$ = $$[$0]; this.$.push($$[$0-1]); 
      grafo.generarPadre(3,"P_Expr"); 
      grafo.generarPadre(2,"ExprSingle"); 
      grafo.generarHijos($$[$0-2],"ExprSingle","P_Expr");
      grafo.generarTexto(`P_Expr.push(ExprSingle.valor); P_Expr.valor = P_Expr.valor;`);
    
break;
case 6:
 
      this.$ = []; grafo.generarHijos("ε");
      grafo.generarTexto(`P_Expr.valor = [];`);
    
break;
case 7:
 
      this.$=[];this.$.push($$[$0-1]);
      grafo.generarPadre(2,"ExprSingle");
      grafo.generarHijos($$[$0-2],"ExprSingle","error") 
      grafo.generarTexto(`P_Expr.valor = []; P_Expr.push(ExprSingle.valor); new Error();`);
      ListaErrores.push({Error:"Error sintactico se recupero en:"+yytext,tipo:"Sintactico",Linea:this._$.first_line,columna:this._$.first_column}); 
    
break;
case 8:
 
    this.$ = $$[$0]; grafo.generarPadre(1,"OrExpr");
    grafo.generarHijos("OrExpr");
    grafo.generarTexto(`ExprSingle.valor = OrExpr.valor;`);
  
break;
case 9:
 
      if($$[$0]==null){this.$=$$[$0-1];}else{this.$=new Logical($$[$0-1],"or",$$[$0]);};
      grafo.generarPadre(2,"P_OrExpr"); 
      grafo.generarPadre(1,"AndExpr"); 
      grafo.generarHijos("AndExpr", "P_OrExpr");
      grafo.generarTexto(`if(P_OrExpr.valor == null){OrExpr.valor = AndExpr}else{OrExpr.valor = new Logical(AndExpr,"or",P_OrExpr);}`);
    
break;
case 10:
 
      if($$[$0]==null){this.$=$$[$0-1];}else{this.$=new Logical($$[$0-1],"or",$$[$0]);}
      grafo.generarPadre(3, "P_OrExpr"); 
      grafo.generarPadre(2, "AndExpr"); 
      grafo.generarHijos($$[$0-2], "AndExpr", "P_OrExpr");
      grafo.generarTexto(`if(P_OrExpr.valor == null){P_OrExpr.valor = AndExpr;}else{P_OrExpr.valor = new Logical(AndExpr,"or",P_OrExpr);}`);
    
break;
case 11:
 
      this.$ = null; grafo.generarHijos("ε"); 
      grafo.generarTexto(`P_OrExpr.valor = null;`);
    
break;
case 12:
 
      if($$[$0]==null){this.$=$$[$0-1];}else{this.$=new Logical($$[$0-1],"and",$$[$0]);};
      grafo.generarPadre(2, "P_AndExpr"); 
      grafo.generarPadre(1, "ComparisonExpr"); 
      grafo.generarHijos("ComparisonExpr", "P_AndExpr");
      grafo.generarTexto(`if(P_AndExpr.valor == null){AndExpr.valor = ComparisonExpr;}else{AndExpr.valor = new Logical(ComparisonExpr,"and",P_AndExpr);}`);
    
break;
case 13:
 
      if($$[$0]==null){this.$=$$[$0-1];}else{this.$=new Logical($$[$0-1],"and",$$[$0]);}; 
      grafo.generarPadre(3, "P_AndExpr"); 
      grafo.generarPadre(2, "ComparisonExpr"); 
      grafo.generarHijos($$[$0-2], "ComparisonExpr", "P_AndExpr");
      grafo.generarTexto(`if(P_AndExpr.valor == null){P_AndExpr.valor = ComparisonExpr;}else{P_AndExpr.valor = new Logical(ComparisonExpr,"and",P_AndExpr);}`);
    
break;
case 14:
 
      this.$ = null; grafo.generarHijos("ε");
      grafo.generarTexto(`P_AndExpr.valor = null;`);
    
break;
case 15:
 
      if($$[$0]==null){this.$=$$[$0-1];}else{this.$=$$[$0]; this.$.izquierdo = $$[$0-1];} 
      grafo.generarPadre(2, "SUB_AdditiveExpr"); 
      grafo.generarPadre(1, "AdditiveExpr"); 
      grafo.generarHijos("AdditiveExpr","SUB_AdditiveExpr");
      grafo.generarTexto(`if(SUB_AdditiveExpr.valor == null){ComparisonExpr.valor = AdditiveExpr.valor;}else{SUB_AdditiveExpr.izq = AdditiveExpr.valor}`);
    
break;
case 16:
 
      this.$ = new ComparisonExp(null,$$[$0-1],$$[$0]);
      grafo.generarPadre(2, "AdditiveExpr");
      grafo.generarPadre(1, "GeneralComp");
      grafo.generarHijos("GeneralComp","AdditiveExpr");
      grafo.generarTexto(`SUB_AdditiveExpr.valor = new ComparisonExp(GeneralComp.valor, AdditiveExpr.valor);`);
    
break;
case 17:
 
      this.$ = null; grafo.generarHijos("ε");
      grafo.generarTexto(`SUB_AdditiveExpr.valor = null;`);
    
break;
case 18: case 19: case 20: case 21: case 22: case 23:
 this.$ = $$[$0]; grafo.generarHijos($$[$0]); grafo.generarTexto(`GeneralComp.valor = ${$$[$0]}`); 
break;
case 24:
 
      if($$[$0]==null){this.$=$$[$0-1];}else{this.$=$$[$0]; this.$.izquierdo = $$[$0-1];}; 
      grafo.generarPadre(2,"P_AdditiveExpr");
      grafo.generarPadre(1,"MultiplicativeExpr"); 
      grafo.generarHijos("MultiplicativeExpr", "P_AdditiveExpr");
      grafo.generarTexto(`if(P_AdditiveExpr == null){AdditiveExpr.valor = MultiExpr.valor}else{P_AdditiveExpr.izq = P_MultiExpr}`);
    
break;
case 25:
 
      if($$[$0]==null){this.$=new Arithmetic(null,$$[$0-2],$$[$0-1]);}else{this.$ = $$[$0]; this.$.izquierdo = $$[$0-1];} 
      grafo.generarPadre(3,"P_AdditiveExpr");
      grafo.generarPadre(2, "MultiplicativeExpr"); 
      grafo.generarHijos($$[$0-2], "MultiplicativeExpr", "P_AdditiveExpr");
      grafo.generarTexto(`if(P_AdditiveExpr == null){P_AdditiveExpr.valor = new Arithmetic(${$$[$0-2]},MultiExpr.valor);}else{P_AdditiveExpr.izq = P_MultiExpr}`);
    
break;
case 26:
 
      if($$[$0]==null){this.$=new Arithmetic(null,$$[$0-2],$$[$0-1]);}else{this.$ = $$[$0]; this.$.izquierdo = $$[$0-1];} 
      grafo.generarPadre(3,"P_AdditiveExpr");
      grafo.generarPadre(2,"MultiplicativeExpr"); 
      grafo.generarHijos($$[$0-2], "MultiplicativeExpr", "P_AdditiveExpr");
      grafo.generarTexto(`if(P_AdditiveExpr == null){P_AdditiveExpr.valor = new Arithmetic(${$$[$0-2]},MultiExpr.valor);}else{P_AdditiveExpr.izq = P_MultiExpr}`);
    
break;
case 27:
 
      this.$ = null; grafo.generarHijos("ε");
      grafo.generarTexto(`P_AdditiveExpr.valor = null;`);
    
break;
case 28:
 
      if($$[$0]==null){this.$=$$[$0-1];}else{this.$=$$[$0]; this.$.izquierdo = $$[$0-1];}; 
      grafo.generarPadre(2,"P_MultiplicativeExpr");
      grafo.generarPadre(1,"UnaryExpr"); 
      grafo.generarHijos("UnaryExpr", "P_MultiplicativeExpr");
      grafo.generarTexto(`if(P_MultiExpr == null){MultiExpr.valor = UnaryExpr}else{P_MultiExpr.izq = UnaryExpr};`);
    
break;
case 29:
 
      if($$[$0]==null){this.$=new Arithmetic(null,$$[$0-2],$$[$0-1]);}else{this.$ = $$[$0]; this.$.izquierdo = $$[$0-1]; };
      grafo.generarPadre(3,"P_MultiplicativeExpr");
      grafo.generarPadre(2,"UnaryExpr"); 
      grafo.generarHijos($$[$0-2], "UnaryExpr", "P_MultiplicativeExpr");
      grafo.generarTexto(`if(P_MultiExpr.valor == null){P_MultiExpr.valor = new Arithmetic(${$$[$0-2]}, UnaryExpr);}else{P_MultiExpr.izq = UnaryExpr}`);
    
break;
case 30:
 
      if($$[$0]==null){this.$=new Arithmetic(null,$$[$0-2],$$[$0-1]);}else{this.$ = $$[$0]; this.$.izquierdo = $$[$0-1]; };
      grafo.generarPadre(3,"P_MultiplicativeExpr");
      grafo.generarPadre(2,"UnaryExpr");  
      grafo.generarHijos($$[$0-2], "UnaryExpr", "P_MultiplicativeExpr");
      grafo.generarTexto(`if(P_MultiExpr.valor == null){P_MultiExpr.valor = new Arithmetic(${$$[$0-2]}, UnaryExpr);}else{P_MultiExpr.izq = UnaryExpr}`);
    
break;
case 31:
 
      if($$[$0]==null){this.$=new Arithmetic(null,$$[$0-2],$$[$0-1]);}else{this.$ = $$[$0]; this.$.izquierdo = $$[$0-1]; }; 
      grafo.generarPadre(3, "P_MultiplicativeExpr");
      grafo.generarPadre(2, "UnaryExpr");
      grafo.generarHijos($$[$0-2], "UnaryExpr", "P_MultiplicativeExpr");
      grafo.generarTexto(`if(P_MultiExpr.valor == null){P_MultiExpr.valor = new Arithmetic(${$$[$0-2]}, UnaryExpr);}else{P_MultiExpr.izq = UnaryExpr}`);
    
break;
case 32:
 
      if($$[$0]==null){this.$=new Arithmetic(null,$$[$0-2],$$[$0-1]);}else{this.$ = $$[$0]; this.$.izquierdo = $$[$0-1]; }; 
      grafo.generarPadre(3, "P_MultiplicativeExpr");
      grafo.generarPadre(2, "UnaryExpr"); 
      grafo.generarHijos($$[$0-2], "UnaryExpr", "P_MultiplicativeExpr");
      grafo.generarTexto(`if(P_MultiExpr.valor == null){P_MultiExpr.valor = new Arithmetic(${$$[$0-2]}, UnaryExpr);}else{P_MultiExpr.izq = UnaryExpr}`);
    
break;
case 33:
 
      this.$ = null; grafo.generarHijos("ε");
      grafo.generarTexto(`P_MultiplicativeExpr.valor = null;`);
    
break;
case 34:
 
      this.$ = $$[$0]; grafo.generarPadre(1, "PathExpr");
      grafo.generarHijos("PathExpr");
      grafo.generarTexto(`UnaryExpr.valor = PathExpr.valor;`);
    
break;
case 35:
 
      this.$=new Unary($$[$0-1], $$[$0]); grafo.generarPadre(2, "UnaryExpr");
      grafo.generarHijos($$[$0-1],"UnaryExp");
      grafo.generarTexto(`UnaryExpr.valor = new Unary(${$$[$0-1]}, UnaryExpr.valor);`);
    
break;
case 36:
 
      this.$=new Unary($$[$0-1], $$[$0]); 
      grafo.generarPadre(2, "UnaryExpr");
      grafo.generarHijos($$[$0-1],"UnaryExp");
      grafo.generarTexto(`UnaryExpr.valor = new Unary(${$$[$0-1]}, UnaryExpr.valor);`);
    
break;
case 37:
 
      this.$ = $$[$0]; grafo.generarPadre(2, "SUB_BARRA");
      grafo.generarHijos($$[$0-1], "SUB_BARRA");
      grafo.generarTexto(`PathExpr.valor = SUB_BARRA.valor`);
    
break;
case 38:
 
      $$[$0][0].tipo=TipoPath.REL;this.$=new PathExp($$[$0]);
      grafo.generarPadre(2, "RelativePathExpr");
      grafo.generarHijos($$[$0-1], "RelativePathExpr");
      grafo.generarTexto(`RelativePathExpr[0].tipo = Relativo; PathExpr.valor = new PathExp(RelativePathExpr.valor);`);
    
break;
case 39:
 
      this.$=new PathExp($$[$0]); grafo.generarPadre(1, "RelativePathExpr");
      grafo.generarHijos("RelativePathExpr");
      grafo.generarTexto(`PathExpr.valor = new PathExp(RelativePathExpr.valor);`);
    
break;
case 40:
 
      $$[$0][0].tipo=TipoPath.ABS;this.$=new PathExp($$[$0]);
      grafo.generarPadre(1, "RelativePathExpr");
      grafo.generarHijos("RelativePathExpr");
      grafo.generarTexto(`RelativePathExpr[0].tipo = Absoluto; SUB_BARRA.valor = new PathExp(RelativePathExpr.valor);`);
    
break;
case 41:
 
      this.$=new PathExp([]); grafo.generarHijos("ε");
      grafo.generarTexto(`SUB_BARRA.valor = new Path(new Array[]);`);
    
break;
case 42:
 
      $$[$0].push($$[$0-1]); $$[$0].reverse(); this.$ = $$[$0];
      grafo.generarPadre(2, "P_RelativePathExpr");
      grafo.generarPadre(1, "StepExpr"); 
      grafo.generarHijos("StepExpr", "P_RelativePathExpr");
      grafo.generarTexto(`P_RelativePathExpr.push(StepExpr.valor); RelativePathExpr.valor = P_RelativePathExpr.valor;`);
    
break;
case 43:
 
      this.$ = $$[$0]; $$[$0-1].tipo = TipoPath.ABS; this.$.push($$[$0-1]);
      grafo.generarPadre(3, "P_RelativePathExpr");
      grafo.generarPadre(2, "StepExpr");
      grafo.generarHijos($$[$0-2], "StepExpr", "P_RelativePathExpr");
      grafo.generarTexto(`StepExpr.tipo = Absoluto; P_RelativePathExpr.push(StepExpr.valor);`);
    
break;
case 44:
 
      this.$ = $$[$0]; $$[$0-1].tipo = TipoPath.REL; this.$.push($$[$0-1]);
      grafo.generarPadre(3, "P_RelativePathExpr");
      grafo.generarPadre(2, "StepExpr");
      grafo.generarHijos($$[$0-2], "StepExpr", "P_RelativePathExpr");
      grafo.generarTexto(`StepExpr.tipo = Relativo; P_RelativePathExpr.push(StepExpr.valor);`);
    
break;
case 45:
 
      this.$ = []; grafo.generarHijos("ε");
      grafo.generarTexto(`P_RelativePathExpr = [];`);
    
break;
case 46:
 
      this.$ = $$[$0]; grafo.generarPadre(1, "PostfixExpr");
      grafo.generarHijos("PostfixExpr");
      grafo.generarTexto(`StepExpr.valor = PostfixExpr.valor`);
    
break;
case 47:
 
      this.$ = $$[$0]; grafo.generarPadre(1, "AxisStep");
      grafo.generarHijos("AxisStep");
      grafo.generarTexto(`StepExpr.valor = AxisStep.valor`);
    
break;
case 48:
 
      this.$ = $$[$0-1]; this.$.predicado = $$[$0]; 
      grafo.generarPadre(2, "SUB_PredicateList");
      grafo.generarPadre(1, "ForwardStep");
      grafo.generarHijos("ForwardStep", "SUB_PredicateList");
      grafo.generarTexto(`ForwardStep.predicado = SUB_PredicateList.valor; AxisStep.valor = ForwardStep.valor;`);
    
break;
case 49:
 
      this.$ = $$[$0-1]; this.$.predicado = $$[$0]; grafo.generarPadre(2, "SUB_PredicateList");
      grafo.generarPadre(1, "ReverseStep");
      grafo.generarHijos("ReverseStep", "SUB_PredicateList");
      grafo.generarTexto(`ReverseStep.predicado = SUB_PredicateList.valor; AxisStep.valor = ReverseStep.valor;`);
    
break;
case 50:
 
      this.$ = $$[$0]; grafo.generarPadre(1,"PredicateList");
      grafo.generarHijos("PredicateList");
      grafo.generarTexto(`SUB_PredicateList.valor = PredicateList.valor`);
    
break;
case 51:
 
      this.$ = []; grafo.generarHijos("ε");
      grafo.generarTexto(`SUB_PredicateList.valor = [];`);
    
break;
case 52:
 
      this.$ = $$[$0]; this.$.push($$[$0-1]); this.$.reverse(); 
      grafo.generarPadre(2, "P_PredicateList");
      grafo.generarPadre(1, "Predicate");
      grafo.generarHijos("Predicate", "P_PredicateList");
      grafo.generarTexto(`P_PredicateList.push(Predicate); PredicateList.valor = P_PredicateList.valor`);
    
break;
case 53:
 
      this.$ = $$[$0]; this.$.push($$[$0-1]);
      grafo.generarPadre(2, "P_PredicateList");
      grafo.generarPadre(1, "Predicate");
      grafo.generarHijos("Predicate", "P_PredicateList");
      grafo.generarTexto(`P_PredicateList.push(Predicate);`);
    
break;
case 54:
 
      this.$ = []; grafo.generarHijos("ε");
      grafo.generarTexto(`P_PredicateList = [];`);
    
break;
case 55:
 
    this.$=$$[$0]; 
    grafo.generarPadre(1, "AbbrevForwardStep");
    grafo.generarHijos("AbbrevForwardStep");
    grafo.generarTexto(`ForwardStep.valor = AbbrevForwardStep.valor`);
  
break;
case 56:
 
    this.$=$$[$0-1]; this.$.nombre=$$[$0]; 
    grafo.generarPadre(2, "NameTest");
    grafo.generarPadre(1, "ForwardAxis");
    grafo.generarHijos("ForwardAxis", "NameTest");
    grafo.generarTexto(`ForwardAxis.nombre = NameTest.valor; ForwardStep.valor = ForwardAxis.valor`);
  
break;
case 57:
 
    this.$=new Atributo($$[$0],[],TipoPath.ABS);
    grafo.generarPadre(2, "NameTest");
    grafo.generarHijos($$[$0-1], "NameTest");
    grafo.generarTexto(`AbbrevForwardStep.valor = new Atributo(NameTest.valor);`);
  
break;
case 58:
 
    this.$=new Camino($$[$0],[],TipoPath.ABS);
    grafo.generarPadre(1, "NameTest");
    grafo.generarHijos("NameTest");
    grafo.generarTexto(`AbbrevForwardStep.valor = new Camino(NameTest.valor);`);
  
break;
case 59:
 this.$=new Child(null,[],TipoPath.ABS); grafo.generarHijos($$[$0-1],$$[$0]); grafo.generarTexto(`ForwardAxis.valor = new Child();`); 
break;
case 60:
 this.$=new Descendant(null,[],TipoPath.ABS); grafo.generarHijos($$[$0-1],$$[$0]); grafo.generarTexto(`ForwardAxis.valor = new Descendant();`); 
break;
case 61:
 this.$=new Attribute(null,[],TipoPath.ABS); grafo.generarHijos($$[$0-1],$$[$0]); grafo.generarTexto(`ForwardAxis.valor = new Attribute();`); 
break;
case 62:
 this.$=new Self(null,[],TipoPath.ABS); grafo.generarHijos($$[$0-1],$$[$0]); grafo.generarTexto(`ForwardAxis.valor = new Self();`); 
break;
case 63:
 this.$=new DescSelf(null,[],TipoPath.ABS); grafo.generarHijos($$[$0-1],$$[$0]); grafo.generarTexto(`ForwardAxis.valor = new DescSelf();`); 
break;
case 64:
 this.$=new FollowSibling(null,[],TipoPath.ABS); grafo.generarHijos($$[$0-1],$$[$0]); grafo.generarTexto(`ForwardAxis.valor = new FollowSibling();`); 
break;
case 65:
 this.$=new Follow(null,[],TipoPath.ABS); grafo.generarHijos($$[$0-1],$$[$0]); grafo.generarTexto(`ForwardAxis.valor = new Follow();`); 
break;
case 66:
  
break;
case 67:
 
    this.$ = $$[$0]; grafo.generarPadre(1, "NameTest");
    grafo.generarHijos("NameTest");
    grafo.generarTexto(`NodeTest.valor = NameTest.valor;`);
  
break;
case 68: case 69:
 this.$ = $$[$0]; grafo.generarHijos($$[$0]); grafo.generarTexto(`NameTest.valor = ${$$[$0]};`); 
break;
case 70:
 
    this.$=$$[$0]; grafo.generarPadre(1, "AbbrevReverseStep");
    grafo.generarHijos("AbbrevReverseStep");
    grafo.generarTexto(`ReverseStep.valor = AbbrevReverseStep.valor`);
  
break;
case 71:
 
    this.$=$$[$0-1]; this.$.nombre=$$[$0]; 
    grafo.generarPadre(2, "NameTest");
    grafo.generarPadre(1, "ReverseAxis");
    grafo.generarHijos("ReverseAxis","NameTest");
    grafo.generarTexto(`ReverseAxis.nombre = NameTest; ReverseStep.valor = ReverseAxis;`);
  
break;
case 72:
 this.$=new CaminoInverso("*",[],TipoPath.ABS); grafo.generarHijos($$[$0]); grafo.generarTexto(`caminoInverso = new CaminoInverso(); caminoInverso.tipo = Absoluto; AbbrevReverseStep.valor = caminoInverso;`); 
break;
case 73:
 this.$=new Parent(null,[],TipoPath.ABS); grafo.generarHijos($$[$0-1],$$[$0]); grafo.generarTexto(`parent = new Parent(); parent.tipo = Absoluto; ReverseAxis.valor = parent;`); 
break;
case 74:
 this.$=new Ancestor(null,[],TipoPath.ABS); grafo.generarHijos($$[$0-1],$$[$0]); grafo.generarTexto(`ancestor = new Ancestor(); ancestor.tipo = Absoluto; ReverseAxis.valor = ancestor;`); 
break;
case 75:
 this.$=new PrecedingSibling(null,[],TipoPath.ABS); grafo.generarHijos($$[$0-1],$$[$0]); grafo.generarTexto(`precedingS = new PrecedingSibling(); precedingS.tipo = Absoluto; ReverseAxis.valor = precedingS;`); 
break;
case 76:
 this.$=new Preceding(null,[],TipoPath.ABS); grafo.generarHijos($$[$0-1],$$[$0]); grafo.generarTexto(`preceding = new Preceding(); preceding.tipo = Absoluto; ReverseAxis.valor = preceding;`); 
break;
case 77:
 this.$=new AncestorSelf(null,[],TipoPath.ABS); grafo.generarHijos($$[$0-1],$$[$0]); grafo.generarTexto(`ancestorS = new AncestorSelf(); ancestorS.tipo = Absoluto; ReverseAxis.valor = ancestorS;`); 
break;
case 78:
 
    this.$ = $$[$0-1]; this.$.predicado = $$[$0]; 
    grafo.generarPadre(2, "SUB_PredicateList");
    grafo.generarPadre(1, "PrimaryExpr");
    grafo.generarHijos("PrimaryExpr","SUB_PredicateList");
    grafo.generarTexto(`PrimaryExpr.predicado = SUB_PredicateList.valor; PostfixExpr.valor = PrimaryExpr.valor`);
  
break;
case 79:
 this.$ = $$[$0-1]; grafo.generarPadre(2, "ExprSingle"); grafo.generarHijos($$[$0-2],"ExprSingle",$$[$0]); grafo.generarTexto(`Predicate.valor = ExprSingle.valor;`); 
break;
case 80:
 this.$ = $$[$0]; grafo.generarPadre(1, "Literal");grafo.generarHijos("Literal"); grafo.generarTexto("PrimaryExpr.valor = literal.valor"); 
break;
case 81:
 this.$ = $$[$0]; grafo.generarPadre(1, "FunctionCall");grafo.generarHijos("FunctionCall"); grafo.generarTexto("PrimaryExpr.valor = functionCall.valor"); 
break;
case 82:
 this.$ = $$[$0]; grafo.generarPadre(1, "ContextItemExpr");grafo.generarHijos("ContextItemExpr"); grafo.generarTexto("PrimaryExpr.valor = contextItemExpr.valor"); 
break;
case 83:
 this.$ = $$[$0]; grafo.generarPadre(1, "ParenthesizedExpr");grafo.generarHijos("ParenthesizedExpr"); grafo.generarTexto("PrimaryExpr.valor = ParenthesizedExpr.valor"); 
break;
case 84:
 this.$=new Literal(Tipo.INTEGER,Number($$[$0])); grafo.generarHijos($$[$0]); grafo.generarTexto(`return literal = new Literal(${$$[$0]}); literal.tipo = INTEGER;`); 
break;
case 85:
 this.$=new Literal(Tipo.DECIMAL,Number($$[$0])); grafo.generarHijos($$[$0]); grafo.generarTexto(`return literal = new Literal(${$$[$0]}); literal.tipo = DECIMAL;`); 
break;
case 86:
 this.$=new Literal(Tipo.STRING,$$[$0]); grafo.generarHijos($$[$0]); grafo.generarTexto(`return literal = new Literal(${$$[$0]}); literal.tipo = STRING;`); 
break;
case 87:
 this.$ = new CallFunction([],TipoPath.ABS,$$[$0-2]); grafo.generarHijos($$[$0-2],$$[$0-1],$$[$0]); grafo.generarTexto(`functionCall = new CallFunction(); functionCall.tipo = Absoluto;`);
break;
case 88:
 this.$=new ContextItemExpr([],TipoPath.ABS); grafo.generarHijos($$[$0]); grafo.generarTexto(`contextItemExpr =  new ContextItemExpr(); contextItemExpr.tipo = Absoluto;`); 
break;
case 89:
 this.$=[]; grafo.generarHijos($$[$0-1],$$[$0]); grafo.generarTexto(`ParenthesizedExpr.valor = [];`); 
break;
case 90:
 this.$=$$[$0-1]; grafo.generarHijos($$[$0-2],$$[$0-1],$$[$0]); grafo.generarTexto(`ParenthesizedExpr.valor = ExprSingle.valor;`); 
break;
}
},
table: [{2:[1,3],3:1,4:2,5:4,8:5,9:6,12:7,15:8,24:9,26:$V0,27:$V1,28:10,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},{1:[3]},{1:[2,1]},{1:[2,2]},{1:$Vq,2:[1,55],6:54,7:$Vr},o($Vs,[2,8]),o($Vs,$Vt,{10:57,11:$Vu}),o($Vv,$Vw,{13:59,14:$Vx}),o($Vy,[2,17],{16:61,17:62,18:[1,63],19:[1,64],20:[1,65],21:[1,66],22:[1,67],23:[1,68]}),o($Vz,$VA,{25:69,26:$VB,27:$VC}),o($VD,$VE,{29:72,30:$VF,31:$VG,32:$VH,33:$VI}),o($VJ,[2,34]),{26:$V0,27:$V1,28:77,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},{26:$V0,27:$V1,28:78,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},o([1,2,7,11,14,18,19,20,21,22,23,26,27,31,32,33,74,83],[2,41],{39:17,41:18,42:19,72:20,43:21,45:22,75:23,76:24,77:25,78:26,49:27,50:28,64:29,65:30,51:38,36:79,38:80,30:$V2,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp}),{30:$V2,38:81,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},o($VJ,[2,39]),o($VJ,$VK,{40:82,35:$VL,37:$VM}),o($VN,[2,46]),o($VN,[2,47]),o($VN,$VO,{44:85,46:86,47:87,73:$VP}),o($VN,$VO,{46:86,47:87,44:89,73:$VP}),o($VN,$VO,{46:86,47:87,44:90,73:$VP}),o($VQ,[2,80]),o($VQ,[2,81]),o($VQ,[2,82]),o($VQ,[2,83]),o($VQ,[2,55]),{30:$V2,51:91,63:$VR},o($VQ,[2,70]),{30:$V2,51:93,63:$VR},o($VQ,[2,84]),o($VQ,[2,85]),o($VQ,[2,86]),o($VQ,$VS,{82:[1,94]}),o($VQ,[2,88]),{5:96,8:5,9:6,12:7,15:8,24:9,26:$V0,27:$V1,28:10,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,83:[1,95],84:$Vp},{30:$V2,51:97,63:$VR},o($VQ,[2,58]),{54:[1,98]},{54:[1,99]},{54:[1,100]},{54:[1,101]},{54:[1,102]},{54:[1,103]},{54:[1,104]},{54:[1,105]},o($VQ,[2,72]),{54:[1,106]},{54:[1,107]},{54:[1,108]},{54:[1,109]},{54:[1,110]},o($VQ,[2,69]),{1:[2,3]},{1:[2,4]},{5:111,8:5,9:6,12:7,15:8,24:9,26:$V0,27:$V1,28:10,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},o($Vs,[2,9]),{9:112,12:7,15:8,24:9,26:$V0,27:$V1,28:10,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},o($Vv,[2,12]),{12:113,15:8,24:9,26:$V0,27:$V1,28:10,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},o($Vy,[2,15]),{15:114,24:9,26:$V0,27:$V1,28:10,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},o($VT,[2,18]),o($VT,[2,19]),o($VT,[2,20]),o($VT,[2,21]),o($VT,[2,22]),o($VT,[2,23]),o($Vz,[2,24]),{24:115,26:$V0,27:$V1,28:10,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},{24:116,26:$V0,27:$V1,28:10,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},o($VD,[2,28]),{26:$V0,27:$V1,28:117,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},{26:$V0,27:$V1,28:118,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},{26:$V0,27:$V1,28:119,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},{26:$V0,27:$V1,28:120,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},o($VJ,[2,35]),o($VJ,[2,36]),o($VJ,[2,37]),o($VJ,[2,40]),o($VJ,[2,38]),o($VJ,[2,42]),{30:$V2,39:121,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},{30:$V2,39:122,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},o($VN,[2,78]),o($VN,[2,50]),o($VN,$VU,{48:123,47:124,73:$VP}),{5:125,8:5,9:6,12:7,15:8,24:9,26:$V0,27:$V1,28:10,30:$V2,34:11,35:$V3,37:$V4,38:16,39:17,41:18,42:19,43:21,45:22,49:27,50:28,51:38,52:$V5,53:$V6,55:$V7,56:$V8,57:$V9,58:$Va,59:$Vb,60:$Vc,61:$Vd,63:$Ve,64:29,65:30,66:$Vf,67:$Vg,68:$Vh,69:$Vi,70:$Vj,71:$Vk,72:20,75:23,76:24,77:25,78:26,79:$Vl,80:$Vm,81:$Vn,82:$Vo,84:$Vp},o($VN,[2,48]),o($VN,[2,49]),o($VQ,[2,56]),o($VQ,$VS),o($VQ,[2,71]),{83:[1,126]},o($VQ,[2,89]),{83:[1,127]},o($VQ,[2,57]),o($VV,[2,59]),o($VV,[2,60]),o($VV,[2,61]),o($VV,[2,62]),o($VV,[2,63]),o($VV,[2,64]),o($VV,[2,65]),o($VV,[2,66]),o($VV,[2,73]),o($VV,[2,74]),o($VV,[2,75]),o($VV,[2,76]),o($VV,[2,77]),{1:$Vq,2:[1,129],6:128,7:$Vr},o($Vs,$Vt,{10:130,11:$Vu}),o($Vv,$Vw,{13:131,14:$Vx}),o($Vy,[2,16]),o($Vz,$VA,{25:132,26:$VB,27:$VC}),o($Vz,$VA,{25:133,26:$VB,27:$VC}),o($VD,$VE,{29:134,30:$VF,31:$VG,32:$VH,33:$VI}),o($VD,$VE,{29:135,30:$VF,31:$VG,32:$VH,33:$VI}),o($VD,$VE,{29:136,30:$VF,31:$VG,32:$VH,33:$VI}),o($VD,$VE,{29:137,30:$VF,31:$VG,32:$VH,33:$VI}),o($VJ,$VK,{40:138,35:$VL,37:$VM}),o($VJ,$VK,{40:139,35:$VL,37:$VM}),o($VN,[2,52]),o($VN,$VU,{47:124,48:140,73:$VP}),{74:[1,141]},o($VQ,[2,87]),o($VQ,[2,90]),{1:[2,5]},{1:[2,7]},o($Vs,[2,10]),o($Vv,[2,13]),o($Vz,[2,25]),o($Vz,[2,26]),o($VD,[2,29]),o($VD,[2,30]),o($VD,[2,31]),o($VD,[2,32]),o($VJ,[2,43]),o($VJ,[2,44]),o($VN,[2,53]),o($VQ,[2,79])],
defaultActions: {2:[2,1],3:[2,2],54:[2,3],55:[2,4],128:[2,5],129:[2,7]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse (input) {
    var self = this,
        stack = [0],
        tstack = [], // token stack
        vstack = [null], // semantic value stack
        lstack = [], // location stack
        table = this.table,
        yytext = '',
        yylineno = 0,
        yyleng = 0,
        recovering = 0,
        TERROR = 2,
        EOF = 1;

    var args = lstack.slice.call(arguments, 1);

    //this.reductionCount = this.shiftCount = 0;

    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    // copy state
    for (var k in this.yy) {
      if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
        sharedState.yy[k] = this.yy[k];
      }
    }

    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);

    var ranges = lexer.options && lexer.options.ranges;

    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }

    function popStack (n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }

_token_stack:
    var lex = function () {
        var token;
        token = lexer.lex() || EOF;
        // if token isn't its numeric value, convert
        if (typeof token !== 'number') {
            token = self.symbols_[token] || token;
        }
        return token;
    }

    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        // retreive state number from top of stack
        state = stack[stack.length - 1];

        // use default actions if available
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            // read action for current state and first input
            action = table[state] && table[state][symbol];
        }

_handle_error:
        // handle parse error
        if (typeof action === 'undefined' || !action.length || !action[0]) {
            var error_rule_depth;
            var errStr = '';

            // Return the rule stack depth where the nearest error rule can be found.
            // Return FALSE when no error recovery rule was found.
            function locateNearestErrorRecoveryRule(state) {
                var stack_probe = stack.length - 1;
                var depth = 0;

                // try to recover from error
                for(;;) {
                    // check for error recovery rule in this state
                    if ((TERROR.toString()) in table[state]) {
                        return depth;
                    }
                    if (state === 0 || stack_probe < 2) {
                        return false; // No suitable error recovery rule available.
                    }
                    stack_probe -= 2; // popStack(1): [symbol, action]
                    state = stack[stack_probe];
                    ++depth;
                }
            }

            if (!recovering) {
                // first see if there's any chance at hitting an error recovery rule:
                error_rule_depth = locateNearestErrorRecoveryRule(state);

                // Report error
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push("'"+this.terminals_[p]+"'");
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line '+(yylineno+1)+":\n"+lexer.showPosition()+"\nExpecting "+expected.join(', ') + ", got '" + (this.terminals_[symbol] || symbol)+ "'";
                } else {
                    errStr = 'Parse error on line '+(yylineno+1)+": Unexpected " +
                                  (symbol == EOF ? "end of input" :
                                              ("'"+(this.terminals_[symbol] || symbol)+"'"));
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected,
                    recoverable: (error_rule_depth !== false)
                });
            } else if (preErrorSymbol !== EOF) {
                error_rule_depth = locateNearestErrorRecoveryRule(state);
            }

            // just recovered from another error
            if (recovering == 3) {
                if (symbol === EOF || preErrorSymbol === EOF) {
                    throw new Error(errStr || 'Parsing halted while starting to recover from another error.');
                }

                // discard current lookahead and grab another
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                symbol = lex();
            }

            // try to recover from error
            if (error_rule_depth === false) {
                throw new Error(errStr || 'Parsing halted. No suitable error recovery rule available.');
            }
            popStack(error_rule_depth);

            preErrorSymbol = (symbol == TERROR ? null : symbol); // save the lookahead token
            symbol = TERROR;         // insert generic error symbol as new lookahead
            state = stack[stack.length-1];
            action = table[state] && table[state][TERROR];
            recovering = 3; // allow 3 real symbols to be shifted before reporting a new error
        }

        // this shouldn't happen, unless resolve defaults are off
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: '+state+', token: '+symbol);
        }

        switch (action[0]) {
            case 1: // shift
                //this.shiftCount++;

                stack.push(symbol);
                vstack.push(lexer.yytext);
                lstack.push(lexer.yylloc);
                stack.push(action[1]); // push state
                symbol = null;
                if (!preErrorSymbol) { // normal execution/no error
                    yyleng = lexer.yyleng;
                    yytext = lexer.yytext;
                    yylineno = lexer.yylineno;
                    yyloc = lexer.yylloc;
                    if (recovering > 0) {
                        recovering--;
                    }
                } else {
                    // error just occurred, resume old lookahead f/ before error
                    symbol = preErrorSymbol;
                    preErrorSymbol = null;
                }
                break;

            case 2:
                // reduce
                //this.reductionCount++;

                len = this.productions_[action[1]][1];

                // perform semantic action
                yyval.$ = vstack[vstack.length-len]; // default to $$ = $1
                // default location, uses first token for firsts, last for lasts
                yyval._$ = {
                    first_line: lstack[lstack.length-(len||1)].first_line,
                    last_line: lstack[lstack.length-1].last_line,
                    first_column: lstack[lstack.length-(len||1)].first_column,
                    last_column: lstack[lstack.length-1].last_column
                };
                if (ranges) {
                  yyval._$.range = [lstack[lstack.length-(len||1)].range[0], lstack[lstack.length-1].range[1]];
                }
                r = this.performAction.apply(yyval, [yytext, yyleng, yylineno, sharedState.yy, action[1], vstack, lstack].concat(args));

                if (typeof r !== 'undefined') {
                    return r;
                }

                // pop off stack
                if (len) {
                    stack = stack.slice(0,-1*len*2);
                    vstack = vstack.slice(0, -1*len);
                    lstack = lstack.slice(0, -1*len);
                }

                stack.push(this.productions_[action[1]][0]);    // push nonterminal (reduce)
                vstack.push(yyval.$);
                lstack.push(yyval._$);
                // goto new state = table[STATE][NONTERMINAL]
                newState = table[stack[stack.length-2]][stack[stack.length-1]];
                stack.push(newState);
                break;

            case 3:
                // accept
                return true;
        }

    }

    return true;
}};

  const {Tipo,TipoPath,Comando} = require("./AST/Entorno");
  const {Logical} = require("./Expresion/Logical");
  const {Arithmetic, Unary} = require("./Expresion/Arithmetics")
  const {Literal,PathExp} = require("./Expresion/Expresiones");
  const { ComparisonExp } = require('./Expresion/Comparison')
  const { Atributo,Camino,Child,Descendant,Attribute,Self,DescSelf,FollowSibling,Follow } = require('./Expresion/axes')
  const { CaminoInverso,Parent,Ancestor,PrecedingSibling,AncestorSelf,Preceding } = require('./Expresion/axes')
  const { ContextItemExpr,CallFunction } = require('./Expresion/postfix')
  const { grafoCST } = require('../CST')
  
  var grafo = new grafoCST(); 

  var ListaErrores = []
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:return "ROR"
break;
case 1:return "RAND"
break;
case 2:return "DIV"
break;
case 3:return "IDIV"
break;
case 4:return "MOD"
break;
case 5:return "RRETURN"
break;
case 6:return "RFOR"
break;
case 7:return "RIN"
break;
case 8:return "RTO"
break;
case 9:return "EQ"
break;
case 10:return "NE"
break;
case 11:return "LT"
break;
case 12:return "LE"
break;
case 13:return "GT"
break;
case 14:return "GE"
break;
case 15:return "RCHILD"
break;
case 16:return "RDESSELF"
break;
case 17:return "RDESCENDANT"
break;
case 18:return "RATTRIBUTE"
break;
case 19:return "RSELF"
break;
case 20:return "RFOLLOWSIBLING"
break;
case 21:return "RFOLLOW"
break;
case 22:return "RNAMESPACE"
break;
case 23:return "RPARENT"
break;
case 24:return "RANCESTORORSELF"
break;
case 25:return "RANCESTOR"
break;
case 26:return "RPRECEDSIBLING"
break;
case 27:return "RPRECED"
break;
case 28:return "DECIMAL"
break;
case 29:return "INTEGER"
break;
case 30: yy_.yytext = yy_.yytext.substr(1,yy_.yyleng-2); return "CADENA" 
break;
case 31:return "NOMBRE"
break;
case 32:return "DOBLEBARRA"
break;
case 33:return "BARRA"
break;
case 34:return "ARROBA"
break;
case 35:return "CORA"
break;
case 36:return "CORB"
break;
case 37:return "MAS"
break;
case 38:return "MENOS"
break;
case 39:return "POR"
break;
case 40:return "MAYORIG"
break;
case 41:return "MENORIG"
break;
case 42:return "DIFERENTE"
break;
case 43:return "MENOR"
break;
case 44:return "MAYOR"
break;
case 45:return "IGUAL"
break;
case 46:return "PIPE"
break;
case 47:return "COMA"
break;
case 48:return "DOLAR"
break;
case 49:return "ADMIRACION"
break;
case 50:return "ARROBA"
break;
case 51:return "DOBLEPUNTO"
break;
case 52:return "PARENTESISA"
break;
case 53:return "PARENTESISC"
break;
case 54:return "INTERROGACIONC"
break;
case 55:return "PUNTO"
break;
case 56:return "DOBLEDOSPUNTOS"
break;
case 57:return "DOSPUNTOS"
break;
case 58:
break;
case 59:
break;
case 60: ListaErrores.push({Error:'Este es un error léxico: ' + yy_.yytext,tipo:"Lexico", Linea: yy_.yylloc.first_line , columna:yy_.yylloc.first_column}) 
break;
}
},
rules: [/^(?:or\b)/i,/^(?:and\b)/i,/^(?:div\b)/i,/^(?:idiv\b)/i,/^(?:mod\b)/i,/^(?:return\b)/i,/^(?:for\b)/i,/^(?:in\b)/i,/^(?:to\b)/i,/^(?:eq\b)/i,/^(?:ne\b)/i,/^(?:lt\b)/i,/^(?:le\b)/i,/^(?:gt\b)/i,/^(?:ge\b)/i,/^(?:child\b)/i,/^(?:descendant-or-self\b)/i,/^(?:descendant\b)/i,/^(?:attribute\b)/i,/^(?:self\b)/i,/^(?:following-sibling\b)/i,/^(?:following\b)/i,/^(?:namespace\b)/i,/^(?:parent\b)/i,/^(?:ancestor-or-self\b)/i,/^(?:ancestor\b)/i,/^(?:preceding-sibling\b)/i,/^(?:preceding\b)/i,/^(?:(\.[0-9]+)|([0-9]+\.[0-9]+))/i,/^(?:[0-9]+)/i,/^(?:("[^"]*")|('[^']*'))/i,/^(?:([a-zA-ZñÑ_])([a-zA-ZñÑ0-9_-]|\.)*)/i,/^(?:\/\/)/i,/^(?:\/)/i,/^(?:@)/i,/^(?:\[)/i,/^(?:\])/i,/^(?:\+)/i,/^(?:-)/i,/^(?:\*)/i,/^(?:>=)/i,/^(?:<=)/i,/^(?:!=)/i,/^(?:<)/i,/^(?:>)/i,/^(?:=)/i,/^(?:\|)/i,/^(?:,)/i,/^(?:\$)/i,/^(?:!)/i,/^(?:@)/i,/^(?:\.\.)/i,/^(?:\()/i,/^(?:\))/i,/^(?:\?)/i,/^(?:\.)/i,/^(?:::)/i,/^(?::)/i,/^(?:[ \r\t]+)/i,/^(?:\n)/i,/^(?:.)/i],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = XpathDesc;
exports.Parser = XpathDesc.Parser;
exports.parse = function () { return XpathDesc.parse.apply(XpathDesc, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}